import React from "react";
// Common Chip component

import Chip from "@mui/material/Chip";

interface CustomChipProps {
  label: string;
  sx?: any;
  backgroundColor?: string;
  color?: string;
}

const CustomChip: React.FC<CustomChipProps> = ({
  label,
  sx,
  backgroundColor,
  color = "#000000",
}) => {
  return (
    <Chip
      label={label}
      sx={{
        fontWeight: 500,
        lineHeight: "15px",
        letterSpacing: "0.32px",
        textAlign: "left",
        height: "23px",
        minWidth: "100px",
        ...sx,
        backgroundColor: backgroundColor,
        color: color,
      }}
    />
  );
};

export default CustomChip;
